<!--客户运维-->
<template>
  <div class="mainArea ClientMaintain">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent clearfix">

        <!-- 内容左边区域 -->
        <div class="contentLeftArea">
          <!-- 搜索框 -->
          <div class="searchBox clearfix">
            <el-input class="searchInput" v-model="companyData.search_str" placeholder="企业名称" clearable></el-input>
            <i class="el-icon-search btnSearch" @click="getCompanyList"></i>
          </div>
          <!-- 公司列表 -->
          <ul class="companyList" v-loading="companyData.loading">
            <li
              class="list"
              :class="{active: item.isActive}"
              v-for="(item, index) in companyData.list"
              :key="index"
              @click="switchCompany(item.company_id, index)" :title="item.company_name">{{item.company_name}}</li>
          </ul>
        </div>

        <!-- 内容右边区域 -->
        <div class="contentRightArea">
          <el-tabs v-model="companyData.now.activeTab">

            <!-- 联系人信息 -->
            <el-tab-pane label="联系人信息" name="contact">
              <!-- 添加按钮 -->
              <el-button type="primary" class="addBtn" @click="operateDialogInfo('addContact')">添 加</el-button>
              <!-- 表格信息 -->
              <el-table
                v-loading="contactData.loading"
                :data="contactData.list"
                style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="expandForm">
                      <el-form-item label="备注：">
                        <span>{{ props.row.remark }}</span>
                      </el-form-item>
                      <el-form-item label="录入人：">
                        <span>{{ props.row.operation_user }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  label="姓名"
                  prop="name">
                </el-table-column>
                <el-table-column
                  label="部门职位"
                  prop="job_title">
                </el-table-column>
                <el-table-column
                  label="手机号码"
                  prop="mobile">
                </el-table-column>
                <el-table-column
                  label="固定电话"
                  prop="phone">
                </el-table-column>
                <el-table-column
                  label="QQ"
                  prop="qq">
                </el-table-column>
                <el-table-column
                  label="微信"
                  prop="wechat">
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialogInfo('alterContact',scope.row)">修改</el-button>
                    <el-button type="text" @click="operateDialogInfo('deleteContact',scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="paging" v-if="contactData.pageCount > 1">
                <el-pagination
                  @current-change="contactHandleCurrentChange"
                  :current-page.sync="contactData.paging.page"
                  layout="prev, pager, next, jumper"
                  :page-count="contactData.pageCount">
                </el-pagination>
              </div>
            </el-tab-pane>

            <!-- 安装记录 -->
            <el-tab-pane label="安装记录" name="install">
              <!-- 添加按钮 -->
              <el-button type="primary" class="addBtn" @click="operateDialogInfo('addInstall')">添 加</el-button>
              <!-- 表格信息 -->
              <el-table
                v-loading="installData.loading"
                :data="installData.list"
                style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="expandForm">
                      <el-form-item label="说明：">
                        <span>{{ props.row.desc }}</span>
                      </el-form-item>
                      <el-form-item label="安装人：">
                        <span>{{ props.row.operation_user }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  label="固件版本"
                  prop="firmware_version">
                </el-table-column>
                <el-table-column
                  label="平板APP版本"
                  prop="app_version">
                </el-table-column>
                <el-table-column
                  label="柜体数量"
                  prop="cabinet_amount">
                </el-table-column>
                <el-table-column
                  label="箱格数量"
                  prop="box_amount">
                </el-table-column>
                <el-table-column
                  label="柜体编号"
                  prop="cabinet_number">
                </el-table-column>
                <el-table-column
                  label="有线/3G/4G"
                  prop="phone">
                </el-table-column>
                <el-table-column
                  label="安装时间"
                  prop="install_date">
                </el-table-column>
                <el-table-column
                  label="出货清单">
                  <template slot-scope="scope">
                    <a class="download" :href="scope.row.file" download="出货清单">下载</a>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialogInfo('alterInstall',scope.row)">编辑</el-button>
                    <el-button type="text" @click="operateDialogInfo('deleteInstall',scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="paging" v-if="installData.pageCount > 1">
                <el-pagination
                  @current-change="installHandleCurrentChange"
                  :current-page.sync="installData.paging.page"
                  layout="prev, pager, next, jumper"
                  :page-count="installData.pageCount">
                </el-pagination>
              </div>
            </el-tab-pane>

            <!-- 运维记录 -->
            <el-tab-pane label="运维记录" name="maintain">
              <!-- 添加按钮 -->
              <el-button type="primary" class="addBtn" @click="operateDialogInfo('addMaintain')">添 加</el-button>
              <!-- 表格信息 -->
              <el-table
                v-loading="maintainData.loading"
                class="maintainTable"
                :data="maintainData.list"
                style="width: 100%">
                <el-table-column
                  label="运维人员"
                  prop="name"
                  width="100px">
                </el-table-column>
                <!-- 单行显示文本内容 -->
                <el-table-column
                  label="运维内容"
                  prop="content"
                  show-overflow-tooltip>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="paging" v-if="maintainData.pageCount > 1">
                <el-pagination
                  @current-change="maintainHandleCurrentChange"
                  :current-page.sync="maintainData.paging.page"
                  layout="prev, pager, next, jumper"
                  :page-count="maintainData.pageCount">
                </el-pagination>
              </div>
            </el-tab-pane>

          </el-tabs>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 删除联系人 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'deleteContact'">
            <p class="text">
              删除
              <span class="bold">
                ({{dialogData.info.name}})
              </span>
              联系人？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteContact()">确认</el-button>
            </div>
          </div>

          <!-- 添加或修改联系人信息 -->
          <div
            v-else-if="dialogData.type === 'addContact' || dialogData.type === 'alterContact'">
            <el-form
              label-width="130px"
              :model="dialogData.info">
              <el-form-item label="姓名:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="部门职位:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.job_title"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="手机号码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.mobile"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="固定电话:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.phone"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="QQ:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.qq"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="微信:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.wechat"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="备注:">
                <div class="inputBox">
                  <el-input type="textarea" class="inputDeposit" rows="5" v-model="dialogData.info.remark"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateContact()">确 认</el-button>
            </div>
          </div>

          <!-- 添加或修改安装信息 -->
          <div
            v-else-if="dialogData.type === 'addInstall' || dialogData.type === 'alterInstall'">
            <el-form
              label-width="130px"
              :model="dialogData.info">
              <el-form-item label="固件版本:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.firmware_version"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="平板APP版本:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.app_version"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="柜体数量:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.cabinet_amount"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="箱格数量:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.box_amount"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="柜体编号:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.cabinet_number"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="有线/3G/4G:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.phone"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="安装时间:">
                <div class="inputBox">
                  <el-date-picker
                    v-model="dialogData.info.install_date"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="出货清单:">
                <div class="inputBox">
                  <el-upload
                    action="string"
                    accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :show-file-list="true"
                    :http-request="uploadFile">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="说明:">
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" v-model="dialogData.info.desc"></el-input>
                </div>
              </el-form-item>
              
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateInstallRecord()">确 认</el-button>
            </div>
          </div>

          <!-- 删除安装记录 -->
          <div
            class="changeStatusWrapper"
            v-else-if="dialogData.type === 'deleteInstall'">
            <p class="text">
              删除固件版本为
              <span class="bold">
                {{dialogData.info.firmware_version}}
              </span>
              安装记录？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteInstallRecord()">确认</el-button>
            </div>
          </div>

          <!-- 添加运维记录 -->
          <div v-else>
            <el-form
              label-width="130px"
              :model="dialogData.info">
              <el-form-item label="运维人员:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="运维内容:">
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" rows="6" v-model="dialogData.info.content"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateMaintenanceRecord()">确 认</el-button>
            </div>
          </div>
        </el-dialog>

      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import {
      showToast,
      localUserInfo,
      deepCopy
    } from "../../../../static/js/utility/utility.js"
  import { maintainApi } from "../../../../static/js/api.js"
  import * as config from "../../../../static/js/config.js"
  import axios from 'axios'

  export default {
    name: 'ClientMaintain',
    components:{
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 公司数据
        companyData: {
          // 搜索字段
          search_str: '',
          // 公司列表
          list: [],
          // 当前显示公司
          now: {
            // 公司id
            companyId: '',
            // 右侧tab显示，默认首次显示联系人信息
            activeTab: 'contact'
          },
          loading: false
        },
        // 联系人数据
        contactData: {
          paging: {
            page: 1,
            perPage: 10
          },
          list: [],
          loading: false
        },
        // 安装列表数据
        installData: {
          paging: {
            page: 1,
            perPage: 10
          },
          list: [],
          loading: false
        },
        // 运维列表数据
        maintainData: {
          paging: {
            page: 1,
            perPage: 10
          },
          list: [],
          loading: false
        }
      }
    },
    mounted(){
      let vm = this
      vm.getCompanyList()
    },
    created: async function () {
    },
    methods: {
      // 操作客户信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        console.log('type', type)
        let addContactInfo = {
          id: '' ,
          name: '',
          mobile:'',
          phone: '',
          qq: '',
          wechat: '',
          job_title: '',
          remark: ''
        }
        let addMaintainInfo = {
          name: '',
          content: ''
        }
        let addInstallInfo = {
          id: '',
          firmware_version: '',
          app_version:'',
          cabinet_number: '',
          box_amount: '',
          cabinet_amount: '',
          phone: '',
          install_date: '',
          file: '',
          desc: ''
        }

        let title = type === 'addContact' ? '添加联系人' : type === 'alterContact' ? '修改联系人' :
                    type === 'deleteContact' ? '删除联系人' : type === 'addMaintain' ? '添加运维记录' : 
                    type === 'addInstall' ? '添加安装记录' : '修改安装记录'
        this.dialogData = {
          type: type,
          title: title,
          visible: !(this.dialogData.visible),
          isReset: false,
          info: type === 'addContact' ? addContactInfo : type === 'addMaintain' ? addMaintainInfo : type === 'addInstall' ? addInstallInfo : deepCopy(info)
        }
        console.log('this', this.dialogData)
      },
      
      // 更新（添加/修改）联系人
      updateContact: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.type === 'addContact' ? '' : vm.dialogData.info.id,
          company_id: vm.companyData.now.companyId,
          name: vm.dialogData.info.name,
          mobile:vm.dialogData.info.mobile,
          phone: vm.dialogData.info.phone,
          qq: vm.dialogData.info.qq,
          wechat: vm.dialogData.info.wechat,
          job_title: vm.dialogData.info.job_title,
          remark: vm.dialogData.info.remark
        }

        // console.log('data', vm.dialogData.info.company_id)
        let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
        if (data.name === '') {
          showToast('姓名不能为空！')
          return
        }
        if (data.mobile === '') {
          showToast('手机不能为空！')
          return
        }else if(!rePhone.test(data.mobile)){
          showToast('请填写11位有效的手机号码')
          return
        }
        // if (data.phone === '') {
        //   showToast('固定电话不能为空！')
        //   return
        // }
        // if (data.qq === '') {
        //   showToast('QQ不能为空！')
        //   return
        // }
        // if (data.wechat === '') {
        //   showToast('微信不能为空！')
        //   return
        // }
        // if (data.job_title === '') {
        //   showToast('部门职位不能为空！')
        //   return
        // }
        // if (data.remark === '') {
        //   showToast('备注不能为空！')
        //   return
        // }

        let res = await maintainApi.updateContact(data)
        if (res.meta.code === 200) {
          showToast(vm.dialogData.type === 'addContact' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getContactList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 删除联系人
      deleteContact: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id
        }

        let res = await maintainApi.deleteContact(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getContactList()
        } else {
          showToast(res.meta.message)
        }
      },

      // 更新（添加/修改）安装记录信息
      updateInstallRecord: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.type === 'addContact' ? '' : vm.dialogData.info.id,
          company_id: vm.companyData.now.companyId,
          firmware_version: vm.dialogData.info.firmware_version,
          app_version:vm.dialogData.info.app_version,
          cabinet_number: vm.dialogData.info.cabinet_number,
          box_amount: vm.dialogData.info.box_amount,
          cabinet_amount: vm.dialogData.info.cabinet_amount,
          phone: vm.dialogData.info.phone,
          install_date: vm.dialogData.info.install_date,
          file: vm.dialogData.info.file,
          desc: vm.dialogData.info.desc
        }

        console.log('data', vm.dialogData.info)

        if (data.firmware_version === '') {
          showToast('固件版本不能为空！')
          return
        }
        if (data.app_version === '') {
          showToast('平板APP版本不能为空！')
          return
        }
        if (data.cabinet_number === '') {
          showToast('柜体数量不能为空！')
          return
        }
        if (data.box_amount === '') {
          showToast('箱格数量不能为空！')
          return
        }
        if (data.cabinet_amount === '') {
          showToast('柜体编号不能为空！')
          return
        }
        if (data.phone === '') {
          showToast('有线/3G/4G不能为空！')
          return
        }
        if (data.install_date === '') {
          showToast('安装时间不能为空！')
          return
        }
        if (data.file === '') {
          showToast('请上传出货清单！')
          return
        }
        if (data.desc === '') {
          showToast('说明不能为空！')
          return
        }
        console.log('data', data)
        // return
        let res = await maintainApi.updateInstallRecord(data)
        if (res.meta.code === 200) {
          showToast(vm.dialogData.type === 'addInstall' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getInstallRecordList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 删除安装记录
      deleteInstallRecord: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id
        }

        let res = await maintainApi.deleteInstallRecord(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getInstallRecordList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新（添加）运维记录信息
      updateMaintenanceRecord: async function () {
        let vm = this
        let data = {
          company_id: vm.companyData.now.companyId,
          name: vm.dialogData.info.name,
          content: vm.dialogData.info.content
        }

        if (data.name === '') {
          showToast('运维人员不能为空！')
          return
        }
        if (data.content === '') {
          showToast('运维内容不能为空！')
          return
        }

        let res = await maintainApi.updateMaintenanceRecord(data)
        if (res.meta.code === 200) {
          showToast('添加成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getMaintenanceRecordList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 安装列表-自定义上传文件
      uploadFile: async function (content) {
        console.log('content', content)
        let vm = this
        let formData = new FormData()
        formData.append('file', content.file)
        let res = await maintainApi.uploadFile(formData, data) 
        if (res.meta.code === 200) {
          showToast('上传成功')
          vm.dialogData.info.file = res.data
          // console.log('file', vm.dialogData.info.file)
        } else {
          showToast(res.meta.message)
        }
      },
      // 上传文件不能超出一个
      handleExceed(files, fileList) {
        showToast(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
        // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },

      // 联系人列表当前页值改变，获取新的联系人列表
      contactHandleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getContactList()
      },
      // 安装列表当前页值改变，获取新的安装列表
      installHandleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getInstallRecordList()
      },
      // 运维列表当前页值改变，获取新的运维列表
      maintainHandleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getMaintenanceRecordList()
      },
      // 获取联系人列表
      getContactList: async function () {
        let vm = this
        let data = vm.contactData.paging
        data.company_id = vm.companyData.now.companyId

        vm.contactData.loading = true
        let res = await maintainApi.getContactList(data)
        vm.contactData.loading = false
        if (res.meta.code === 200) {
          vm.contactData.list = res.data.list
          vm.contactData.pageCount =  res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取安装列表
      getInstallRecordList: async function () {
        let vm = this
        let data = vm.installData.paging
        data.company_id = vm.companyData.now.companyId

        vm.installData.loading = true
        let res = await maintainApi.getInstallRecordList(data)
        vm.installData.loading = false
        if (res.meta.code === 200) {
          vm.installData.list = res.data.list
          vm.installData.pageCount =  res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取运维记录列表
      getMaintenanceRecordList: async function () {
        let vm = this
        let data = vm.maintainData.paging
        data.company_id = vm.companyData.now.companyId

        vm.maintainData.loading = true
        let res = await maintainApi.getMaintenanceRecordList(data)
        vm.maintainData.loading = false
        if (res.meta.code === 200) {
          vm.maintainData.list = res.data.list
          vm.maintainData.pageCount =  res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理公司列表数据
      processCompanyData: function (data) {
        let vm = this
        let list = data
        for (let i in list) {
          list[i].isActive = false
        }

        // 默认首次显示第一个公司信息
        list[0].isActive = true
        vm.companyData.now.companyId = list[0].company_id
        vm.companyData.list = list

      },
      // 获取公司列表
      getCompanyList: async function () {
        let vm = this
        let data = {
          search_str: vm.companyData.search_str
        }

        vm.companyData.loading = true
        let res = await maintainApi.getCompanyList(data)
        vm.companyData.loading = false
        if (res.meta.code === 200) {
          console.log('tag', res.data)
          if (res.data.length === 0) {
            showToast('未找到对应的公司信息！')
          } else {
            vm.processCompanyData(res.data)
          }
        } else {
          showToast(res.meta.message)
        }
      },
      // 切换公司
      switchCompany: function (company_id, index) {
        let vm = this
        // 获取最新的公司id
        vm.companyData.now.companyId = company_id
        // 更新样式active
        let list = vm.companyData.list
        for (let i in list) {
          list[i].isActive = false
        }
        list[index].isActive = true

        vm.companyData.list = list
      }
    },
    watch: {
      // 监听搜索字段清空，获取新的公司列表
      'companyData.search_str': function (newVal) {
        if (newVal === '') {
          this.getCompanyList()
        }
      },
      // 监听信息tab变化,更新对应信息列表
      'companyData.now.activeTab': function (newVal) {
        console.log('当前tab显示', newVal)
        // 获取联系人、安装、运维列表
        if (newVal === 'contact') {
          this.getContactList()
        } else if (newVal === 'install') {
          this.getInstallRecordList()
        } else {
          this.getMaintenanceRecordList()
        }
      },
      // 监听公司公司id变化
      'companyData.now.companyId': function (newVal) {
        console.log('当前显示公司', newVal)
        // 获取联系人、安装、运维列表
        let activeTab = this.companyData.now.activeTab
        if (activeTab === 'contact') {
          this.getContactList()
        } else if (activeTab === 'install') {
          this.getInstallRecordList()
        } else {
          this.getMaintenanceRecordList()
        }
      },
    }
  }

</script>

<style lang="scss" scoped>
.ClientMaintain {
  .mainBodyContent::after{
    height: 100%;
    content: '';
    border-right: 1px solid #E4E7ED;
    visibility: visible;
    position: absolute;
    left: 250px;
    top: 0;
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    .contentLeftArea {
      float: left;
      width: 250px;
      .searchBox {
        width: 100%;
        border-bottom: 1px solid #E4E7ED;
        .searchInput {
          float: left;
          width: 224px;
        }
        .btnSearch {
          float: left;
          color: #cccccc;
          font-size: 20px;
          line-height: 40px;
        }
      }
      .companyList {
        padding: 10px 0;
        .list {
          line-height: 40px;
          text-indent: 1em;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .list.active {
          color: #409EFF;
          border-right: #409EFF solid 1px;
        }
      }
    }
    .contentRightArea {
      padding: 10px;
      margin-left: 280px;
      .addBtn {
        margin-bottom: 10px;
      }
    }
    .download {
      color: #409EFF;
    }
    .expandForm {
      width: 100%;
      .el-form-item{
        width: 100%;
        margin: 0;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Page/Maintain/ClientMaintain.vue